import { Controller } from "stimulus";
import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js';

export default class extends Controller {
  connect() {
    // Initialize the color picker
    $(this.element).colorpicker({
      format: 'rgb', // Options: 'rgb', 'rgba', 'hsl', 'hex'
      fallbackColor: '#3498db', // Default fallback color (gray)
      customClass: 'colorpicker-custom',
      extensions: [
        {
          name: 'swatches',
          options: {
            colors: {
              turquoise: "#1abc9c",
              greenSea: "#16a085",
              emerald: "#2ecc71",
              nephritis: "#27ae60",
              peterRiver: "#3498db",
              belizeHole: "#2980b9",
              amethyst: "#9b59b6",
              wisteria: "#8e44ad",
              wetAsphalt: "#34495e",
              midnightBlue: "#2c3e50",
              sunflower: "#f1c40f",
              carrot: "#e67e22",
              pumpkin: "#d35400",
              alizarin: "#e74c3c",
              pomegranate: "#c0392b",
              clouds: "#ecf0f1",
              silver: "#bdc3c7",
              concrete: "#95a5a6",
              asbestos: "#7f8c8d",
              red: '#f44336',
              pink: '#e91e63',
              purple: '#9c27b0',
              indigo: '#3f51b5',
              blue: '#2196f3',
              teal: '#009688',
              green: '#4caf50',
              yellow: '#ffeb3b',
              orange: '#ff9800'
            },
          },
        },
      ],
    });

    // Set default background color to gray on load
    this.element.style.backgroundColor = '#3498db';

    // Ensure the input has a default value if no color is selected
    if (!this.element.value) {
      this.element.value = '#3498db'; // Set default value to fallback color
      this.element.style.color = '#3498db'; // Set default value to fallback color

    }
    // Set value for edit modal
    if (this.element.value && !(this.element.value == '#3498db')) {
      this.element.value = this.element.value; 
      this.element.style.color = this.element.value; 
      this.element.style.backgroundColor = this.element.value;
    }
 

    // Update input background color when a color is selected
    $(this.element).on('colorpickerChange', (event) => {
      const selectedColor = event.color.toString();
      this.element.style.backgroundColor = selectedColor; // Set the input's background color
      this.element.style.color = selectedColor; // Set the input's background color
    });
  }
}
